export enum OptimizelyFlags {
  LISTING_PAGE_HOST_BIO = 'listing_page_host_bio',
  LISTING_ORDER = 'listing_module_order_web',
  CAMPSITE_LISTING_ORDER = 'campsite_listing_module_order_web',
  SEARCH_SORT_LOGIC = 'search_sort_logic_web',
  TRIP_DETAILS_ORDER = 'trip_details_module_order_web',
  HOMEPAGE_CUSTOM_BANNER_WEB = 'homepage_custom_banner_web',
  FREE_CANCELLATION_PERIOD = 'free_cancellation_period',
  SYSTEM_DOWNTIME = 'system_downtime',
  TRIP_DETAILS_BANNER = 'trip_details_banner',
  BLOG_BANNER = 'blog_banner',
  LISTINGS_NEARBY_THRESHOLD_WEB = 'listings_nearby_threshold_web',
  CAMPGROUNDS_SEARCH_TAB_AND_HOME_TAB = 'campgrounds_web',
  USM_FOR_GUIDE_PAGES = 'usm_for_guide_pages',
  USM_INSTANT_BOOK = 'usm_instant_book',
  MAP_LAYERS = 'map_layers',
  STAY_CAMPGROUND_FEATURE_FILTER = 'stay_campground_feature_filter',
  ROAMLY_WEATHER = 'roamly_weather',
  CAMPGROUND_DATE_CHANGE = 'campground_date_change_ui',
  RV_STAYS_DELIVERY_WEB = 'rv_stays_delivery_web',
  CAPTAIN_BLOG_AI_ENABLED = 'captain_blog_ai_enabled',
  STATIONARY_ACKNOWLEDGMENT = 'stationary_acknowledgment',
  CAMPGROUND_DISCOUNTING_BANNER = 'campgrounds_discounting_banner',
  OUTDOORSY_STAYS = 'outdoorsy_stays',
  ATTENTIVE_ENABLED = 'attentive_enabled',
  SERP_GUIDED_SEARCH = 'serp_guided_search',
  GTM_ENABLED = 'gtm_enabled',
  SUPERHOST_BADGE = 'superhost_badge',
  SITEWIDE_BANNER = 'sitewide_banner',
  UPGRADE_MAPBOX_API = 'upgrade_mapbox_api',
  HOMEPAGE_FOR_YOU_FEED = 'homepage_for_you_feed',
  ESCAPES_ADS = 'escapes_ads',
  PRICE_TOTAL_SRP_2_AB_TEST = 'price_total_srp_2_ab_test',
  AUTO_TO_RVS_LINK = 'auto_to_rvs_link',
  LOYALTY_INCENTIVE = 'loyalty_incentive',
  RENTAL_V_DELIVERY_SEARCH_MODE = 'rental_v_delivery_search_mode',
  POPULAR_CHOICE_WIDGET_ON_LISTING_BILL_V2 = 'popular_choice_widget_on_listing_bill_2',
  LISTING_QUICK_PREVIEW = 'listing_quick_preview',
  AI_POWERED_IMAGE_OPTIMIZATION = 'ai_powered_image_optimization',
  LISTING_PAGE_2_0 = 'listing_page_2_0',
  GUEST_CLAIM_FORM = 'guest_claim_form',
  AI_RENTAL_SUMMARY = 'ai_rental_summary',
  AI_REVIEW_SUMMARY = 'ai_review_summary',
  AI_TRIP_PLANNER = 'ai_trip_planner',
  TOWABLE_GUIDED_SEARCH = 'towable_guided_search',
  KEY_EXCHANGE_APP_DOWNLOAD = 'key_exchange_app_download',
}

export enum ESerpGuidedSearchVariationKey {
  RV_WIZARD_WHERE_TO_START = 'rv_wizard_where_to_start',
  RV_WIZARD_WHICH_RV = 'rv_wizard_which_rv',
  MY_RV_FIT_WHERE_TO_START = 'my_rv_fit_where_to_start',
  RV_MATCHMAKER_WHICH_RV = 'rv_matchmaker_which_rv',
  RV_NAVIGATOR_GUESSWORK = 'rv_navigator_guesswork',
  RV_NAVIGATOR_GET_STARTED = 'rv_navigator_get_started',
  RV_SCOUT_GET_STARTED = 'rv_scout_get_started',
}

export enum EUrgencyListingPageViewsVariationKey {
  ENABLED_51 = 'Enabled_51',
  ENABLED_101 = 'Enabled_101',
  ENABLED_201 = 'Enabled_201',
  ENABLED_BIGGER_THAN_251 = 'enabled_251_', // show the exact number of views
}

export enum EAITripPlannerVariationKey {
  HOME_PAGE = 'home_page',
  SEARCH_RESULTS_PAGE = 'search_results_page',
}
